
const OWNER_COLUMN = 0;
const ROOT_COMMENTS_COLUMN = 1;
const COMMENT_REPLIES_COLUMN = 2;

const matrix = [
  ['article',     'articles',     'articleComments'],
  ['forumThread', 'forumThreads', 'forumThreadComments']
];

function findAndMap(resourceType, f) {
  for(let i = 0; i < matrix.length; i++) {
    const row = matrix[i];
    const columnIndex = row.indexOf(resourceType);

    if(columnIndex >= 0) {
      return f(row, columnIndex);
    }
  }

  throw new Error(`Cannot find resource type ${resourceType}`);
}

export const            isCommentsOwner = resourceType => findAndMap(resourceType, (_, columnIndex) => columnIndex == OWNER_COLUMN);
export const                  isComment = resourceType => findAndMap(resourceType, (_, columnIndex) => columnIndex > OWNER_COLUMN);
export const              isRootComment = resourceType => findAndMap(resourceType, (_, columnIndex) => columnIndex == ROOT_COMMENTS_COLUMN);
export const             isCommentReply = resourceType => findAndMap(resourceType, (_, columnIndex) => columnIndex == COMMENT_REPLIES_COLUMN);
export const      findCommentsOwnerType = resourceType => findAndMap(resourceType, row => row[OWNER_COLUMN]);
export const     findCommentRepliesType = resourceType => findAndMap(resourceType, row => row[COMMENT_REPLIES_COLUMN]);
export const findRowByCommentsOwnerType = commentsOwnerType => matrix.find(row => row[0] === commentsOwnerType);



/** WEBPACK FOOTER **
 ** ./src/members/__shared__/commentsResourceTypes.js
 **/